import { HStack, Table, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getContractTypesCached } from 'services/contractType.cached';
import { ContractType } from 'services/interfaces/contractType';
import { Contract, IContract } from 'shared/models/contract';
import { getContractTypeName } from '../../helpers/contractType';
import ContractTableLine from '../molecules/ContractTableLine';
import { LoadingStt } from '../pages/ContractsPage';
interface ContractsTableProps {
  contracts?: Contract[];
  loading: LoadingStt;
}
const ContractsTable = ({ contracts = [], loading }: ContractsTableProps) => {
  const [contractTypes, setContractTypes] = useState<ContractType[]>([]);

  useEffect(() => {
    getContractTypesCached()
      .then(setContractTypes)
      .catch((e) => {
        console.error('Erro ao carregar tipos de contrato', e);
      });
  }, []);

  if (!loading.stt && !contracts?.length) {
    return (
      <HStack h="200px" justify="center" w="100%">
        <Text variant="regular">Nenhum contrato encontrado</Text>
      </HStack>
    );
  }
  let lines = contracts.map((contract) => (
    <Tr key={contract.id}>
      <ContractTableLine
        contract={contract}
        contractTypeName={getContractTypeName(
          contractTypes,
          contract.contract_type_id,
        )}
      />
    </Tr>
  ));
  if (loading.stt && loading.first) {
    lines = Array.from({ length: 3 }).map((_, index) => {
      const contract = new Contract({} as IContract);
      return (
        <Tr key={index}>
          <ContractTableLine loading={true} contract={contract} />
        </Tr>
      );
    });
  }
  return (
    <Table variant="detailed">
      <Thead>
        <Tr>
          <Th>ID</Th>
          <Th>Tipo</Th>
          <Th>Plano/Serviço</Th>
          <Th>Criado em </Th>
          <Th>Expira em</Th>
          <Th>Valor</Th>
          <Th>Status</Th>
          <Th>Ações</Th>
          <Th>Ver</Th>
        </Tr>
      </Thead>
      <Tbody>{lines}</Tbody>
    </Table>
  );
};
export default ContractsTable;
